// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TermsOfService_TermsOfService_component__Hb5vz{display:flex;flex-direction:column;margin-top:40px;margin-left:48px}.TermsOfService_TermsOfService_termsAndCondText__3IaUB{font-weight:400;font-size:12px;-webkit-text-decoration-color:#1769ff;text-decoration-color:#1769ff;line-height:167%}.TermsOfService_TermsOfService_termsOfServHeader__1_Sbv{font-weight:600;font-size:30px;line-height:153%}.TermsOfService_TermsOfService_termsOfServSubHeadOne__3seC0{font-weight:500;font-size:18px;line-height:156%}.TermsOfService_TermsOfService_mainTextContainer__3juhO{margin-top:40px}.TermsOfService_TermsOfService_paragraphText__3Eto8{width:744px;font-weight:400;font-size:14px;line-height:157%}.TermsOfService_TermsOfService_linkColor___vF3X{color:#1769ff}\n", "",{"version":3,"sources":["webpack://src/features/common/components/TermsOfService/TermsOfService.module.scss"],"names":[],"mappings":"AAGE,gDACE,YAAa,CACb,qBAAsB,CACtB,eAAgB,CAChB,gBAAiB,CAClB,uDAGC,eAAgB,CAChB,cAAe,CACf,qCAA8B,CAA9B,6BAA8B,CAC9B,gBAAiB,CAClB,wDAGC,eAAgB,CAChB,cAAe,CACf,gBAAiB,CAClB,4DAGC,eAAgB,CAChB,cAAe,CACf,gBAAiB,CAClB,wDAGC,eAAgB,CACjB,oDAGC,WAAY,CACZ,eAAgB,CAChB,cAAe,CACf,gBAAiB,CAClB,gDAGC,aAAc","sourcesContent":["@import 'spoton-lib/styles/color-variables';\n\n.TermsOfService {\n  &_component {\n    display: flex;\n    flex-direction: column;\n    margin-top: 40px;\n    margin-left: 48px;\n  }\n\n  &_termsAndCondText {\n    font-weight: 400;\n    font-size: 12px;\n    text-decoration-color: #1769ff;\n    line-height: 167%;\n  }\n\n  &_termsOfServHeader {\n    font-weight: 600;\n    font-size: 30px;\n    line-height: 153%;\n  }\n\n  &_termsOfServSubHeadOne {\n    font-weight: 500;\n    font-size: 18px;\n    line-height: 156%;\n  }\n\n  &_mainTextContainer {\n    margin-top: 40px;\n  }\n\n  &_paragraphText {\n    width: 744px;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 157%;\n  }\n\n  &_linkColor {\n    color: #1769ff;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary10": "var(--primary10)",
	"primary20": "var(--primary20)",
	"primary30": "var(--primary30)",
	"primary50": "var(--primary50)",
	"primary70": "var(--primary70)",
	"primary80": "var(--primary80)",
	"primary90": "var(--primary90)",
	"base10": "var(--base10)",
	"base20": "var(--base20)",
	"base30": "var(--base30)",
	"base50": "var(--base50)",
	"base70": "var(--base70)",
	"base80": "var(--base80)",
	"base90": "var(--base90)",
	"highlightBase20": "var(--#f7f8f9)",
	"white": "var(--white)",
	"black": "var(--black)",
	"shadow": "var(--shadow)",
	"informative10": "var(--informative10)",
	"informative20": "var(--informative20)",
	"informative30": "var(--informative30)",
	"informative50": "var(--informative50)",
	"informative70": "var(--informative70)",
	"informative80": "var(--informative80)",
	"informative90": "var(--informative90)",
	"success10": "var(--success10)",
	"success20": "var(--success20)",
	"success30": "var(--success30)",
	"success50": "var(--success50)",
	"success70": "var(--success70)",
	"success80": "var(--success80)",
	"success90": "var(--success90)",
	"warning10": "var(--warning10)",
	"warning20": "var(--warning20)",
	"warning30": "var(--warning30)",
	"warning50": "var(--warning50)",
	"warning70": "var(--warning70)",
	"warning80": "var(--warning80)",
	"warning90": "var(--warning90)",
	"danger10": "var(--danger10)",
	"danger20": "var(--danger20)",
	"danger30": "var(--danger30)",
	"danger50": "var(--danger50)",
	"danger70": "var(--danger70)",
	"danger80": "var(--danger80)",
	"danger90": "var(--danger90)",
	"loyalty10": "var(--loyalty10)",
	"loyalty20": "var(--loyalty20)",
	"loyalty30": "var(--loyalty30)",
	"loyalty50": "var(--loyalty50)",
	"loyalty70": "var(--loyalty70)",
	"loyalty80": "var(--loyalty80)",
	"loyalty90": "var(--loyalty90)",
	"loyaltyGradient": "var(--loyaltyGradient)",
	"TermsOfService_component": "TermsOfService_TermsOfService_component__Hb5vz",
	"TermsOfService_termsAndCondText": "TermsOfService_TermsOfService_termsAndCondText__3IaUB",
	"TermsOfService_termsOfServHeader": "TermsOfService_TermsOfService_termsOfServHeader__1_Sbv",
	"TermsOfService_termsOfServSubHeadOne": "TermsOfService_TermsOfService_termsOfServSubHeadOne__3seC0",
	"TermsOfService_mainTextContainer": "TermsOfService_TermsOfService_mainTextContainer__3juhO",
	"TermsOfService_paragraphText": "TermsOfService_TermsOfService_paragraphText__3Eto8",
	"TermsOfService_linkColor": "TermsOfService_TermsOfService_linkColor___vF3X"
};
export default ___CSS_LOADER_EXPORT___;
